export default __webpack_public_path__ + "static/media/coolcandies.2c6b1311.jpeg";